export default class GrowthForecastStageDCF {
  /**
   *
   * @param {number} depreciation
   * @param {number} growthWorkingCapital
   * @param {number} capitalExpenditures
   * @param {number} netOperatingProfitAfterTax
   * @param {number} returnOnEquity
   * @param {number} preTaxCashFlow
   * @param {number} returnOnAssets
   * @param {number} analystChosenTwoStepGrowthRate
   * @param {string} sustainableNote
   * @param {string} internalNote
   */
  constructor({
    depreciation = 0,
    growthWorkingCapital = 0,
    capitalExpenditures = 0,
    netOperatingProfitAfterTax = 0,
    returnOnEquity = 0,
    preTaxCashFlow = 0,
    returnOnAssets = 0,
    analystChosenTwoStepGrowthRate = 0,
    sustainableNote = "",
    internalNote = ""
  }) {
    this.depreciation = depreciation
    this.growthWorkingCapital = growthWorkingCapital
    this.capitalExpenditures = capitalExpenditures
    this.netOperatingProfitAfterTax = netOperatingProfitAfterTax
    this.returnOnEquity = returnOnEquity
    this.preTaxCashFlow = preTaxCashFlow
    this.returnOnAssets = returnOnAssets
    this.analystChosenTwoStepGrowthRate = analystChosenTwoStepGrowthRate
    this.sustainableNote = sustainableNote
    this.internalNote = internalNote
  }

  get reinvestmentTotal() {
    return this.depreciation - this.growthWorkingCapital - this.capitalExpenditures
  }

  get reinvestmentRateOnNetOperatingProfitAfterTax() {
    return (this.reinvestmentTotal / this.netOperatingProfitAfterTax) * 100
  }

  get sustainableExpectedGrowthRate() {
    return Math.abs(this.returnOnEquity * this.reinvestmentRateOnNetOperatingProfitAfterTax) / 100
  }

  get reinvestmentRateOnPreTaxCashFlow() {
    return (this.reinvestmentTotal / this.preTaxCashFlow) * 100
  }

  get internalExpectedGrowthRate() {
    return Math.abs(this.returnOnAssets * this.reinvestmentRateOnPreTaxCashFlow) / 100
  }
}